// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.node-picker__wrapper[data-v-a1eb0469]:not(:last-of-type) {
  border-bottom: 1px solid var(--color-border);
}
.node-picker[data-v-a1eb0469] {
  display: flex;
  align-items: center;
  height: 64px;
}
.node-picker__icon[data-v-a1eb0469], .node-picker__preview[data-v-a1eb0469] {
  height: 64px;
  width: 64px;
  margin: 0 var(--secondary-margin);
  display: block;
  flex: 0 0 64px;
}
.node-picker__icon[data-v-a1eb0469] {
  color: var(--color-text-maxcontrast);
}
.node-picker__icon.folder-icon[data-v-a1eb0469] {
  color: var(--color-primary-element);
}
.node-picker__preview[data-v-a1eb0469] {
  overflow: hidden;
  border-radius: calc(var(--border-radius) * 2);
  object-fit: cover;
}
.node-picker__desc[data-v-a1eb0469] {
  display: flex;
  flex-direction: column;
}
.node-picker__desc span[data-v-a1eb0469] {
  white-space: nowrap;
}[data-v-9464bcea] .modal-container__content {
  display: flex;
  overflow: visible;
  flex-direction: column;
}
.conflict-picker[data-v-9464bcea] {
  --margin: 36px;
  --secondary-margin: 18px;
}
.conflict-picker__header[data-v-9464bcea] {
  position: sticky;
  z-index: 10;
  top: 0;
  padding: 0 var(--margin);
  padding-bottom: var(--secondary-margin);
  background-color: var(--color-main-background);
}
.conflict-picker__form[data-v-9464bcea] {
  position: relative;
  overflow: auto;
  padding: 0 var(--margin);
  margin-top: calc(-1 * var(--secondary-margin));
}
.conflict-picker fieldset[data-v-9464bcea] {
  display: grid;
  width: 100%;
  margin-top: calc(var(--secondary-margin) * 1.5);
  padding-bottom: var(--secondary-margin);
  grid-template-columns: 1fr 1fr;
}
.conflict-picker fieldset[data-v-9464bcea] legend {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: calc(var(--secondary-margin) / 2);
}
.conflict-picker fieldset.conflict-picker__all[data-v-9464bcea] {
  position: sticky;
  top: 0;
  margin: 0;
  padding: var(--secondary-margin) 0;
  background-image: linear-gradient(to top, transparent, var(--color-main-background-blur) 10%, var(--color-main-background) 15%);
}
.conflict-picker fieldset.conflict-picker__all + fieldset[data-v-9464bcea] {
  margin-top: 0;
}
.conflict-picker fieldset.conflict-picker__all[data-v-9464bcea] label {
  font-weight: bold;
}
.conflict-picker .button-vue--disabled[data-v-9464bcea] {
  cursor: default;
  opacity: 0.5;
  filter: saturate(0.7);
}
.conflict-picker[data-v-9464bcea] .dialog__actions {
  width: auto;
  margin-inline: 12px;
}
.conflict-picker[data-v-9464bcea] .dialog__actions span.dialog__actions-separator {
  margin-left: auto;
}
@media screen and (max-width: 768px) {
.conflict-picker[data-v-9464bcea] {
    --margin: var(--secondary-margin) !important;
}
.conflict-picker__description[data-v-9464bcea] {
    display: none !important;
}
.conflict-picker fieldset[data-v-9464bcea] {
    grid-template-columns: 1fr !important;
}
.conflict-picker fieldset.conflict-picker__all[data-v-9464bcea] {
    position: static;
}
}
@media screen and (max-width: 512px) {
.conflict-picker[data-v-9464bcea] .dialog__actions {
    flex-wrap: wrap;
}
.conflict-picker[data-v-9464bcea] .dialog__actions span.dialog__actions-separator {
    width: 100%;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/upload/dist/assets/ConflictPicker-CpKPg_rh.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB,CAAC;EACC,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,wBAAwB;EACxB,uCAAuC;EACvC,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,WAAW;EACX,+CAA+C;EAC/C,uCAAuC;EACvC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,kCAAkC;EAClC,+HAA+H;AACjI;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;AACA;IACI,4CAA4C;AAChD;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,qCAAqC;AACzC;AACA;IACI,gBAAgB;AACpB;AACA;AACA;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA","sourcesContent":[".node-picker__wrapper[data-v-a1eb0469]:not(:last-of-type) {\n  border-bottom: 1px solid var(--color-border);\n}\n.node-picker[data-v-a1eb0469] {\n  display: flex;\n  align-items: center;\n  height: 64px;\n}\n.node-picker__icon[data-v-a1eb0469], .node-picker__preview[data-v-a1eb0469] {\n  height: 64px;\n  width: 64px;\n  margin: 0 var(--secondary-margin);\n  display: block;\n  flex: 0 0 64px;\n}\n.node-picker__icon[data-v-a1eb0469] {\n  color: var(--color-text-maxcontrast);\n}\n.node-picker__icon.folder-icon[data-v-a1eb0469] {\n  color: var(--color-primary-element);\n}\n.node-picker__preview[data-v-a1eb0469] {\n  overflow: hidden;\n  border-radius: calc(var(--border-radius) * 2);\n  object-fit: cover;\n}\n.node-picker__desc[data-v-a1eb0469] {\n  display: flex;\n  flex-direction: column;\n}\n.node-picker__desc span[data-v-a1eb0469] {\n  white-space: nowrap;\n}[data-v-9464bcea] .modal-container__content {\n  display: flex;\n  overflow: visible;\n  flex-direction: column;\n}\n.conflict-picker[data-v-9464bcea] {\n  --margin: 36px;\n  --secondary-margin: 18px;\n}\n.conflict-picker__header[data-v-9464bcea] {\n  position: sticky;\n  z-index: 10;\n  top: 0;\n  padding: 0 var(--margin);\n  padding-bottom: var(--secondary-margin);\n  background-color: var(--color-main-background);\n}\n.conflict-picker__form[data-v-9464bcea] {\n  position: relative;\n  overflow: auto;\n  padding: 0 var(--margin);\n  margin-top: calc(-1 * var(--secondary-margin));\n}\n.conflict-picker fieldset[data-v-9464bcea] {\n  display: grid;\n  width: 100%;\n  margin-top: calc(var(--secondary-margin) * 1.5);\n  padding-bottom: var(--secondary-margin);\n  grid-template-columns: 1fr 1fr;\n}\n.conflict-picker fieldset[data-v-9464bcea] legend {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: calc(var(--secondary-margin) / 2);\n}\n.conflict-picker fieldset.conflict-picker__all[data-v-9464bcea] {\n  position: sticky;\n  top: 0;\n  margin: 0;\n  padding: var(--secondary-margin) 0;\n  background-image: linear-gradient(to top, transparent, var(--color-main-background-blur) 10%, var(--color-main-background) 15%);\n}\n.conflict-picker fieldset.conflict-picker__all + fieldset[data-v-9464bcea] {\n  margin-top: 0;\n}\n.conflict-picker fieldset.conflict-picker__all[data-v-9464bcea] label {\n  font-weight: bold;\n}\n.conflict-picker .button-vue--disabled[data-v-9464bcea] {\n  cursor: default;\n  opacity: 0.5;\n  filter: saturate(0.7);\n}\n.conflict-picker[data-v-9464bcea] .dialog__actions {\n  width: auto;\n  margin-inline: 12px;\n}\n.conflict-picker[data-v-9464bcea] .dialog__actions span.dialog__actions-separator {\n  margin-left: auto;\n}\n@media screen and (max-width: 768px) {\n.conflict-picker[data-v-9464bcea] {\n    --margin: var(--secondary-margin) !important;\n}\n.conflict-picker__description[data-v-9464bcea] {\n    display: none !important;\n}\n.conflict-picker fieldset[data-v-9464bcea] {\n    grid-template-columns: 1fr !important;\n}\n.conflict-picker fieldset.conflict-picker__all[data-v-9464bcea] {\n    position: static;\n}\n}\n@media screen and (max-width: 512px) {\n.conflict-picker[data-v-9464bcea] .dialog__actions {\n    flex-wrap: wrap;\n}\n.conflict-picker[data-v-9464bcea] .dialog__actions span.dialog__actions-separator {\n    width: 100%;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
